import React, {Fragment} from "react";
import {s_char_mods} from "../_signals/s_char";

export function displayAttributeModNSC(attr) {
    const mod = s_char_mods.value.filter(m=>m.what === attr).reduce((s, m) => s + m.mmod, 0);

    if (mod === 0) return <Fragment></Fragment>;
    if (mod < 0) return <Fragment>{mod}</Fragment>;
    return <Fragment>+{mod}</Fragment>;
}